import { StateCreator } from "zustand";
import { IDepartment } from "../../../../util/api";

export interface ICreateDepartmentSlice {
  departmentList: IDepartment[];
  setDepartmentList: (departments: IDepartment[]) => void;
}

const _setDepartmentList = (set: any) => (departments: IDepartment[]) =>
  set(() => ({
    departmentList: departments,
  }));

export const createDepartmentSlice: StateCreator<
  ICreateDepartmentSlice,
  [['zustand/devtools', never]],
  [],
  ICreateDepartmentSlice
> = (set) => ({
  departmentList: [],
  setDepartmentList: _setDepartmentList(set),
});